import { Injectable } from "@angular/core";
import { ScreenOrientation } from "@ionic-native/screen-orientation/ngx";
import { StorageService } from "./storage.service";

@Injectable({
  providedIn: "root"
})
export class ScreenOrientationService {

  public orientation: string;

  constructor(private screenOrientation: ScreenOrientation, private storage: StorageService) {}

  async init() {
    const storedOrientation = await this.storage.get("orientation");
    if (storedOrientation) {
      this.orientation = storedOrientation;
      this.lock(storedOrientation);
    }
  }

  get(): string {
    if (this.orientation) {
      return this.orientation;
    } else {
      const orientation = this.screenOrientation.type;
      if (orientation.includes("portrait")) {
        return "portrait";
      } else {
        return "landscape";
      }
    }
  }

  set(orientation: "portrait" | "landscape") {
    this.orientation = orientation;
    this.storage.set("orientation", orientation);
    this.lock(orientation);
  }

  lock(orientation: string) {
    if ((orientation !== "portrait") && (orientation !== "landscape")){
      console.error("Invalid orientation", orientation);
    } else {
      this.screenOrientation.lock(orientation);
    }
  }
}
